import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../images/ergo.png'
import { specialTheme, widthXS } from '../theme'
import LanguageSwitch from './LanguageSwitch'
import useGa4 from '../hooks/useGa4'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: specialTheme.colors.white,
    maxWidth: '100%',
    minHeight: 96,
    [theme.breakpoints.down(widthXS)]: {
      minHeight: 56,
    },
  },
  headerBar: {
    display: 'flex',
    backgroundColor: specialTheme.colors.white,
    maxWidth: 1180,
    minHeight: 81,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  ERGOLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxWidth: 200,
  },
  itemsFlexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}))

const Header = () => {
  const classes = useStyles()
  const { ga4_clickCta } = useGa4()
  
  return (
    <Container className={classes.root}>
      <Grid
        item
        xs={12}
        sm={12}
        xl={12}
        container
        direction="row"
        className={classes.headerBar}
      >
        <Grid item xs={4} sm={4} xl={4}>
          <Grid item>
            <Button
              component={Link}
              to="/"
              disableFocusRipple
              disableRipple
              style={{ backgroundColor: 'transparent' }}
              onClick={() => { ga4_clickCta({cta_name : 'ERGO'})}}
            >
              <img src={logo} className={classes.ERGOLogo} alt="Page Logo" />
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={7} sm={7} xl={7}>
          <Grid item className={classes.itemsFlexEnd}></Grid>
        </Grid>
        <Grid item xs={1} sm={1} xl={1}>
          <LanguageSwitch />
        </Grid>
      </Grid>
    </Container>
  )
}
export default Header
